// Portions Copyright 2019 Jimb Esser (https://github.com/Jimbly/)
// Released under MIT License: https://opensource.org/licenses/MIT
/* eslint-env browser */

/*
  Convert models to GLB with:
  node_modules\.bin\gltf-pipeline.cmd -t -i src/client/models/box.gltf -o src/client/models/box.glb
  // The -t tells it not to embed the textures, but just leave the URIs
 */

const assert = require('assert');

const geom = require('./geom.js');
const glb_parser = require('./glb/parser.js');
const { ATTRIBUTE_TYPE_TO_COMPONENTS } = require('./glb/gltf-type-utils.js');
const renderer = require('./engine.js');
const shaders = require('./shaders.js');
const textures = require('./textures.js');
const { vec4 } = require('./vmath.js');

export let load_count = 0;

let box_glb = 'glTF\x02\0\0\0\xCC\b\0\0h\x05\0\0JSON{"asset":{"generator":"COLLADA2GLTF","version":"2.0"},"scene":0,"scenes":[{"nodes":[0]}],"nodes":[{"children":[1],"matrix":[1,0,0,0,0,0,-1,0,0,1,0,0,0,0,0,1]},{"mesh":0}],"meshes":[{"primitives":[{"attributes":{"NORMAL":1,"POSITION":2,"TEXCOORD_0":3},"indices":0,"mode":4,"material":0}],"name":"Mesh"}],"accessors":[{"bufferView":0,"byteOffset":0,"componentType":5123,"count":36,"max":[23],"min":[0],"type":"SCALAR"},{"bufferView":1,"byteOffset":0,"componentType":5126,"count":24,"max":[1,1,1],"min":[-1,-1,-1],"type":"VEC3"},{"bufferView":1,"byteOffset":288,"componentType":5126,"count":24,"max":[0.5,0.5,0.5],"min":[-0.5,-0.5,-0.5],"type":"VEC3"},{"bufferView":2,"byteOffset":0,"componentType":5126,"count":24,"max":[6,1],"min":[0,0],"type":"VEC2"}],"materials":[{"pbrMetallicRoughness":{"baseColorTexture":{"index":0,"texCoord":0},"metallicFactor":0,"baseColorFactor":[1,1,1,1],"roughnessFactor":1},"name":"Texture","emissiveFactor":[0,0,0],"alphaMode":"OPAQUE","doubleSided":false}],"textures":[{"sampler":0,"source":0}],"samplers":[{"magFilter":9729,"minFilter":9986,"wrapS":10497,"wrapT":10497}],"bufferViews":[{"buffer":0,"byteOffset":0,"byteLength":72,"target":34963},{"buffer":0,"byteOffset":72,"byteLength":576,"byteStride":12,"target":34962},{"buffer":0,"byteOffset":648,"byteLength":192,"byteStride":8,"target":34962}],"buffers":[{"name":"box_textured","byteLength":840}]}H\x03\0\0BIN\0\0\0\x01\0\x02\0\x03\0\x02\0\x01\0\x04\0\x05\0\x06\0\x07\0\x06\0\x05\0\b\0\t\0\n\0\x0B\0\n\0\t\0\f\0\r\0\x0E\0\x0F\0\x0E\0\r\0\x10\0\x11\0\x12\0\x13\0\x12\0\x11\0\x14\0\x15\0\x16\0\x17\0\x16\0\x15\0\0\0\0\0\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0\0\0\0\x80?\0\0\x80?\0\0\0\0\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\0\0\0\0\0\0\0\x80\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0?\0\0\0?\0\0\0\xBF\0\0\0?\0\0\0\xBF\0\0\0?\0\0\0?\0\0\0?\0\0\0?\0\0\0?\0\0\0?\0\0\0?\0\0\0?\0\0\0?\0\0\0\xBF\0\0\0?\0\0\0?\0\0\0?\0\0\0\xBF\0\0\0?\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0?\0\0\0?\0\0\0?\0\0\0?\0\0\0?\0\0\0\xBF\0\0\0?\0\0\0\xBF\0\0\0?\0\0\0?\0\0\0\xBF\0\0\0?\0\0\0\xBF\0\0\0?\0\0\0\xBF\0\0\0\xBF\0\0\0?\0\0\0?\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0?\0\0\0\xBF\0\0\0?\0\0\0?\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0?\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0\xBF\0\0\0?\0\0\0\xBF\0\0\0?\0\0\0\xBF\0\0\0\xBF\0\0\0?\0\0\0?\0\0\0\xBF\0\0\xC0@\0\0\0\0\0\0\xA0@\0\0\0\0\0\0\xC0@\xFE\xFF\x7F?\0\0\xA0@\xFE\xFF\x7F?\0\0\x80@\0\0\0\0\0\0\xA0@\0\0\0\0\0\0\x80@\0\0\x80?\0\0\xA0@\0\0\x80?\0\0\0@\0\0\0\0\0\0\x80?\0\0\0\0\0\0\0@\0\0\x80?\0\0\x80?\0\0\x80?\0\0@@\0\0\0\0\0\0\x80@\0\0\0\0\0\0@@\0\0\x80?\0\0\x80@\0\0\x80?\0\0@@\0\0\0\0\0\0\0@\0\0\0\0\0\0@@\0\0\x80?\0\0\0@\0\0\x80?\0\0\0\0\0\0\0\0\0\0\0\0\xFE\xFF\x7F?\0\0\x80?\0\0\0\0\0\0\x80?\xFE\xFF\x7F?';
{
  let arr = new Uint8Array(box_glb.length);
  for (let ii = 0; ii < box_glb.length; ++ii) {
    arr[ii] = box_glb.charCodeAt(ii);
  }
  box_glb = arr.buffer;
}

export let models = {};

export let default_vshader;
export let default_fshader;

function initShaders() {
  default_vshader = shaders.create(gl.VERTEX_SHADER, '// Portions Copyright 2019 Jimb Esser (https://github.com/Jimbly/)\n// Released under MIT License: https://opensource.org/licenses/MIT\n#pragma WebGL\nprecision highp float;\n\n// per-vertex input\nattribute vec3 POSITION;\n//attribute vec3 COLOR;\nattribute vec2 TEXCOORD;\nattribute vec3 NORMAL;\n\n// per-drawcall input\nuniform mat3 mv_inv_trans;\nuniform mat4 projection;\nuniform mat4 mat_mv;\nuniform vec4 color;\n\n// output\nvarying vec4 interp_color;\nvarying vec2 interp_texcoord;\nvarying vec3 interp_normal_vs;\n// varying vec3 interp_pos_vs;\n\nvoid main(void) {\n  //interp_color = vec4(COLOR * color.rgb, color.a);\n  interp_color = color;\n  interp_texcoord = vec2(TEXCOORD);\n  interp_normal_vs = mv_inv_trans * NORMAL;\n  // gl_Position = vec4(POSITION, 1.0);\n\n  // gl_Position = mat_vp * (mat_m * vec4(POSITION, 1.0));\n  // gl_Position = mvp * vec4(POSITION, 1.0);\n  vec4 pos_vs = mat_mv * vec4(POSITION, 1.0);\n  // interp_pos_vs = pos_vs.xyz;\n  gl_Position = projection * pos_vs;\n}');
  default_fshader = shaders.create(gl.FRAGMENT_SHADER, '// Portions Copyright 2019 Jimb Esser (https://github.com/Jimbly/)\n// Released under MIT License: https://opensource.org/licenses/MIT\n#pragma WebGL\n\nprecision lowp float;\n\nuniform sampler2D tex0; // source\n\nuniform vec3 light_diffuse;\nuniform vec3 light_dir_vs;\nuniform vec3 ambient;\n\nvarying vec4 interp_color;\nvarying vec2 interp_texcoord;\nvarying vec3 interp_normal_vs;\n\nvoid main(void) {\n  vec4 texture0 = texture2D(tex0, interp_texcoord.xy);\n#ifndef NOGAMMA\n  texture0.rgb = texture0.rgb * texture0.rgb; // pow(2)\n#endif\n  vec4 albedo = texture0 * interp_color;\n  if (albedo.a < 0.01) // TODO: Probably don\'t want this, but makes hacking transparent things together easier for now\n    discard;\n\n  vec3 normal_vs = normalize(interp_normal_vs);\n  float diffuse = max(0.0, 0.5 + 0.5 * dot(normal_vs, -light_dir_vs.rgb));\n\n  vec3 light_color = diffuse * light_diffuse.rgb + ambient.rgb;\n  gl_FragColor = vec4(light_color * albedo.rgb, albedo.a);\n\n#ifndef NOGAMMA\n  gl_FragColor.rgb = pow(gl_FragColor.rgb, vec3(1.0/2.0));\n#endif\n}');
}

function Model(url) {
  this.url = url;
  let idx = url.lastIndexOf('/');
  if (idx !== -1) {
    this.base_url = url.slice(0, idx + 1);
  } else {
    this.base_url = '';
  }
}

Model.prototype.load = function () {
  ++load_count;
  let xhr = new XMLHttpRequest();
  xhr.open('GET', this.url, true);
  xhr.responseType = 'arraybuffer';
  xhr.onload = () => {
    --load_count;
    let array_buffer = xhr.response; // Note: not xhr.responseText
    if ((xhr.status === 200 || xhr.status === 0) && array_buffer) {
      this.parse(array_buffer);
    }
  };
  xhr.send(null);
};

const skip_attr = {
  'TANGENT': true
};

Model.prototype.parse = function (glb_data) {
  let glb = glb_parser.parse(glb_data);
  if (!glb) {
    return;
  }
  // Make Geoms for each primitives within each mesh
  let glb_json = glb.getJSON();
  let objs = [];
  for (let ii = 0; ii < glb_json.meshes.length; ++ii) {
    let mesh = glb_json.meshes[ii];
    for (let jj = 0; jj < mesh.primitives.length; ++jj) {
      let primitives = mesh.primitives[jj];
      let material = glb_json.materials[primitives.material];
      let texture = null;
      if (material) {
        // Just grabbing the base color texture, nothing else
        let bct = (material.pbrMetallicRoughness || {}).baseColorTexture || {};
        let texture_def = glb_json.textures && glb_json.textures[bct.index] || {};
        let sampler_def = glb_json.samplers && glb_json.samplers[texture_def.sampler] || {};
        let image = glb_json.images && glb_json.images[texture_def.source] || {};
        if (image.uri) {
          let params = {
            url: `${this.base_url}${image.uri}`,
            filter_mag: sampler_def.magFilter,
            filter_min: sampler_def.minFilter,
            wrap_s: sampler_def.wrapS,
            wrap_t: sampler_def.wrapT
          };
          texture = textures.load(params);
        }
      }
      let format = [];
      let buffers = [];
      let bidx = [];
      let total_size = 0;
      let vert_count = 0;
      for (let attr in primitives.attributes) {
        if (skip_attr[attr]) {
          continue;
        }
        assert(shaders.semantic[attr] !== undefined);
        let accessor = glb_json.accessors[primitives.attributes[attr]];
        assert.equal(accessor.componentType, 5126); // F32
        let geom_format = gl.FLOAT;
        let geom_count = ATTRIBUTE_TYPE_TO_COMPONENTS[accessor.type];
        assert(geom_count);
        let my_vert_count = accessor.count /* / geom_count*/;
        if (!vert_count) {
          vert_count = my_vert_count;
        } else {
          assert.equal(vert_count, my_vert_count);
        }
        format.push([shaders.semantic[attr], geom_format, geom_count]);
        let buffer = glb.getBuffer(accessor);
        buffers.push(buffer);
        bidx.push(0);
        total_size += buffer.length;
      }
      // Interleave
      let verts = new Float32Array(total_size);
      let idx = 0;
      for (let vert = 0; vert < vert_count; ++vert) {
        for (let attr = 0; attr < format.length; ++attr) {
          for (let kk = 0; kk < format[attr][2]; ++kk) {
            verts[idx++] = buffers[attr][bidx[attr]++];
          }
        }
      }
      // Get indices
      let accessor = glb_json.accessors[primitives.indices];
      assert(accessor); // must be an indexed primitive set
      assert.equal(accessor.type, 'SCALAR');
      let idxs = glb.getBuffer(accessor);
      if (accessor.componentType === 5125) {
        // Uint32
        assert(vert_count < 65536); // Fits in 16-bits
        // Just convert to 16-bit
        idxs = new Uint16Array(idxs);
      } else {
        assert.equal(accessor.componentType, 5123); // Uint16
      }
      objs.push({
        geom: geom.create(format, verts, idxs, primitives.mode),
        texture
      });
    }
  }
  // TODO: Something with nodes to tie together and position the meshes
  this.data = {
    objs
    // glb, - Don't keep this, release it and any unreferenced data/buffers
  };
};

Model.prototype.draw = function (mat) {
  renderer.updateMatrices(mat); // before setting shader
  shaders.bind(default_vshader, default_fshader, {
    color: vec4(1, 1, 1, 1)
  });
  let objs = this.data.objs;
  for (let ii = 0; ii < objs.length; ++ii) {
    let obj = objs[ii];
    if (obj.texture) {
      textures.bind(0, obj.texture);
    }
    obj.geom.draw();
  }
};

// Just draw the geometry, without any other binding
Model.prototype.drawGeom = function () {
  let objs = this.data.objs;
  for (let ii = 0; ii < objs.length; ++ii) {
    let obj = objs[ii];
    obj.geom.draw();
  }
};

export function load(url) {
  if (models[url]) {
    return models[url];
  }
  let model = models[url] = new Model(url);
  model.data = models.box.data; // stub until loaded
  model.load();
  return model;
}

export function startup() {
  initShaders();
  let model_box = models.box = new Model('box');
  model_box.parse(box_glb);
}